export * from './Footer';



// WEBPACK FOOTER //
// ./src/components/Common/Footer/index.ts